
  (function(){
    function checkOfferOverflow(){
      document.querySelectorAll('.cab-offers-block__card-desc.is-collapsed').forEach(function(el){
        var btn = el.nextElementSibling;
        if(!btn || !btn.classList.contains('cab-offers-block__more')) return;
        if(el.scrollHeight > el.clientHeight + 1){
          btn.classList.add('is-visible');
        } else {
          btn.classList.remove('is-visible');
        }
      });
    }
    if(document.readyState === 'complete'){
      requestAnimationFrame(checkOfferOverflow);
    } else {
      window.addEventListener('load', function(){ requestAnimationFrame(checkOfferOverflow); });
    }
  })();
